import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';

import { GuestName } from 'components';

const GuestNameContainer = props => <GuestName {...props} />;

const mapStateToProps = (state, { id }) => {
  const { firstName, lastName } = fromReservation.getGuest(state, id);
  return {
    firstName,
    lastName,
  };
};

GuestNameContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(GuestNameContainer);



// WEBPACK FOOTER //
// ./src/containers/GuestName.js